
import React, { useState, useEffect, useRef, useContext } from 'react';
import axios from 'axios';
import { getValores } from '../../services/Maestros/MaestroDoleService';

import { classNames } from 'primereact/utils';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';

import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { FilterMatchMode } from 'primereact/api';

import { useLocalState } from '../../util/useLocalStorage';
import { UsuarioService } from '../../services/Usuario/UsuarioService';
import { UbicacionesService } from '../../services/Ubicaciones/UbicacionesService';
import { ProgressSpinner } from 'primereact/progressspinner';
import { BlockUI } from 'primereact/blockui';

import { TabView, TabPanel } from 'primereact/tabview';
import { FileUpload } from 'primereact/fileupload';
import Ruta from '../Maestro/Ruta';
import { loadGoogleMaps, removeGoogleMaps } from "../GoogleMaps/GoogleMaps";

import { GMap } from 'primereact/gmap';
import { Checkbox } from 'primereact/checkbox';
import { SelectButton } from 'primereact/selectbutton';
import { wktAVertices, verticesAWkt } from './geocercaPoligono';

import{BASE_URL} from '../../services/ApiService/ApiConfig'


const Ubicaciones = () => {


    let _ubicacion = {
        ubicacionId: null,
        nombre: '',
        codigo: '',
        latitud: '',
        longitud: '',
        area: '',
        geocercaPoligono: null,
        esPuntoRetorno: false,
        esPatioSeco: false,
        delincuenteHoras: null,
        estado: 'Activo',
        activo: true,
        tipoUbicacion: {
            nombre: '',
        },
        ubicacionInfoList: [
        ],
        ubicacionTarjetaList: [

        ]


    }

    let _ubicacionInformacion = {
        representante: '',
        representanteTelefono: '',
        representanteCorreo: '',
        responsable: '',
        responsableIdentificacion: '',
        responsableTelefono: '',
        ubicacionInfoId: '',
        zona: '',
        codigoPlantaEmpacadora: '',
        sector: '',
        provincia: '',
        canton: '',
        contenedoresPorDia: '',
        estado: 'Activo',
        activo: true,
    }

    let _tarjeta = {
        tarjetaId: null,
        activo: true,
        estado: 'Activo',
        fechaIngreso: '',
        identificador: '',
        tipoTarjeta: {

        },
        usuario: {

        }
    }

    const roles = JSON.parse(localStorage.getItem('roles') || '[]');
    const isAdmin = roles.includes('ADMINISTRADOR') || roles.includes('UBICACION');
    const isUbicacionTarjeta = roles.includes('UBICACION_TARJETA') || roles.includes('ADMINISTRADOR');

    const [googleMapsReady, setGoogleMapsReady] = useState(false);
    const [dialogVisible, setDialogVisible] = useState(false);
    const [markerTitle, setMarkerTitle] = useState("");
    const [draggableMarker, setDraggableMarker] = useState(false);
    const [overlays, setOverlays] = useState(null);
    const [selectedPosition, setSelectedPosition] = useState(null);
    const [ubicacionUsuarioLatitud, setUbicacionUsuarioLatitud] = useState("");
    const [ubicacionUsuarioLongitud, setUbicacionUsuarioLongitud] = useState("");


    const infoWindow = useRef(null);
    const google = window.google;

    var map;

    useEffect(() => {
        navigator.geolocation.getCurrentPosition(function (position) {
            console.log("Latitude is :", position.coords.latitude);
            setUbicacionUsuarioLatitud(position.coords.latitude);
            console.log("Longitude is :", position.coords.longitude);
            setUbicacionUsuarioLongitud(position.coords.longitude);
        });


    }, [])

    useEffect(() => {

        loadGoogleMaps(() => {
            setGoogleMapsReady(true);
        });

        return () => {
            removeGoogleMaps();
        };
    }, []);

    const usuarioService = new UsuarioService();
    const ubicacionesService = new UbicacionesService();

    const [ubicaciones, setUbicaciones] = useState(null);
    const [habilitarGuardar, setHabilitarGuardar] = useState(true);

    const [ubicacion, setUbicacion] = useState(_ubicacion);
    const [ubicacionInformacion, setUbicacionInformacion] = useState(_ubicacionInformacion);
    const [selectedMonitoreoDet, setSelectedMonitoreoDets] = useState(null);
    const [submitted, setSubmitted] = useState(false);

    const toast = useRef(null);
    const toast2 = useRef(null);
    const dt = useRef(null);

    /**JWT */
    const [jwt, setJwt] = useLocalState("", "jwt");

    /**Headers Token */
    const config = {
        headers: {
            'Content-Type': "application/json",
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            Authorization: `Bearer ${jwt}`
        }
    }

    /**Usuario */
    const [usuario, setUsuario] = useState("");
    const [username, setUsername] = useLocalState("", "username");
    const [ubicacionDialog, setUbicacionDialog] = useState("");
    const [archivoDialog, setArchivoDialog] = useState("");
    const [rutaDialog, setRutaDialog] = useState("");
    const [tarjetaDialog, setTarjetaDialog] = useState("");
    const [identificadorTarjeta, setIdentificadorTarjeta] = useState("");

    /**Tarjetas */
    // Zonas de producción (maestro DOL-0000-0002) para el combo de la ubicación (RF-C1)
    const [zonasProduccion, setZonasProduccion] = useState([]);
    useEffect(() => {
        getValores('DOL-0000-0002').then(setZonasProduccion).catch(() => setZonasProduccion([]));
    }, []);

    // Cantones / Localidades (maestro DOL-0000-0005) para el combo (RF-B8)
    const [cantonesLocalidad, setCantonesLocalidad] = useState([]);
    useEffect(() => {
        getValores('DOL-0000-0005').then(setCantonesLocalidad).catch(() => setCantonesLocalidad([]));
    }, []);

    const [listaTarjetas, setListaTarjetas] = useState([]);
    const [listaTipoUbicaciones, setListaTipoUbicaciones] = useState([]);
    const [listaTipoTarjetas, setListaTipoTarjetas] = useState([]);
    const [tipoUbicacion, setTipoUbicacion] = useState("");
    const [tarjeta, setTarjeta] = useState("");
    const [tipotarjeta, setTipoTarjeta] = useState("");
    const [nuevaTarjeta, setNuevaTarjeta] = useState(_tarjeta);
    const [blocked, setBlocked] = useState(false);

    const [ubicacionId, setUbicacionId] = useState("");

    const [listaUbicacionesEnviar, setListaUbicacionesEnviar] = useState([]);

    const [displayMapa, setDisplayMapa] = useState(false);

    // ---- DOLE tramos a puerto: poligono opcional de la geocerca (diseno 3.3) ----
    // El mapa (GMap) registra sus eventos una sola vez al montarse: lo que cambia se lee de refs.
    const [modoMapa, setModoMapa] = useState('punto');
    const modoMapaRef = useRef('punto');
    const mapaRef = useRef(null);
    const mapaListoEnRef = useRef(0);
    const poligonoRef = useRef(null);
    const ubicacionRef = useRef(null);



    useEffect(() => { usuarioService.getUsuario(username).then(data => setUsuario(data)); }, []);
    useEffect(() => { ubicacionesService.getListaUbicaciones().then(data => { setUbicaciones(data); console.log(data); }) }, []);
    useEffect(() => { ubicacionesService.getListaTarjetas().then(data => setListaTarjetas(data)) }, []);
    useEffect(() => { ubicacionesService.getListaTipoUbicaciones().then(data => setListaTipoUbicaciones(data)); }, []);
    useEffect(() => { ubicacionesService.getListaTipoTarjeta().then(data => setListaTipoTarjetas(data)); }, []);


    const onMapClick = (event) => {
        if (modoMapaRef.current === 'poligono') {
            // el clic que abrio el mapa puede caer sobre el mapa recien creado: no cuenta como vertice
            if (Date.now() - mapaListoEnRef.current < 600) return;
            agregarVertice(event.latLng.lat(), event.latLng.lng());
            return;
        }
        //setDialogVisible(true);
        setSelectedPosition(event.latLng);
        console.log(event.latLng.lat());
        addMarker2(event.latLng.lat(), event.latLng.lng())
        //padreMarker(event.latLng.lat(), event.latLng.lng())

    };



    const onOverlayClick = (event) => {
        let isMarker = event.overlay.getTitle !== undefined;

        if (isMarker) {
            let title = event.overlay.getTitle();
            infoWindow.current = infoWindow.current || new google.maps.InfoWindow();
            infoWindow.setContent("<div>" + title + "</div>");
            infoWindow.open(event.map, event.overlay);
            event.map.setCenter(event.overlay.getPosition());

            toast.current.show({
                severity: "info",
                summary: "Marker Selected",
                detail: title
            });
        } else {
            toast.current.show({
                severity: "info",
                summary: "Shape Selected",
                detail: ""
            });
        }
    };

    const handleDragEnd = (event) => {
        toast.current.show({
            severity: "info",
            summary: "Marker Dragged",
            detail: event.overlay.getTitle()
        });
        console.log(event.overlay.position.lat());
        console.log(event.overlay.position.lng());

        let _monitoreoDet = { ...ubicacion };
        // _monitoreoDet.area = (event.overlay.position.lat() + "," + event.overlay.position.lng());
        _monitoreoDet.area = ""
        _monitoreoDet.area = "MARKER (" + event.overlay.position.lat() + " " + event.overlay.position.lng() + ")"
        // _monitoreoDet.area = (event.overlay.position.lat() + "," + event.overlay.position.lng())
        console.log(_monitoreoDet);
        setUbicacion(_monitoreoDet);

        const words2 = _monitoreoDet.area.split(/[()]+/);
        const latlng = words2[1].split(' ');
        const splitLat = latlng[0];
        const splitLng = latlng[1];
        console.log(splitLat + "," + splitLng);



    };

    const addMarker = () => {
        let newMarker = new google.maps.Marker({
            position: {
                lat: selectedPosition.lat(),
                lng: selectedPosition.lng()
            },
            title: markerTitle,
            draggable: draggableMarker
        });
        console.log(newMarker.position.lat());
        console.log(newMarker.position.lng());

        setOverlays([...overlays, newMarker]);
        setDialogVisible(false);
        setDraggableMarker(false);
        setMarkerTitle("");
    };

    const addMarker2 = (lat, lng) => {

        let _ubicacion = { ...ubicacion };
        var _lat = lat;
        var _lng = lng;

        if (_ubicacion.area == null || _ubicacion.area == "") {

            //const myLatlng = { lat: lat, lng: lng };

            let newMarker = new google.maps.Marker({
                position: {
                    lat: _lat,
                    lng: _lng
                },
                animation: google.maps.Animation.DROP,
                title: markerTitle,
                draggable: true
            });

            newMarker.setMap(map)
            setOverlays([newMarker]);

            _ubicacion.area = "MARKER (" + _lat + " " + _lng + ")";
            setUbicacion(_ubicacion);
        }

        if (_ubicacion.area.includes("MARKER")) {

            const words2 = _ubicacion.area.split(/[()]+/);
            const latlng = words2[1].split(' ');
            var splitLat = latlng[0];
            splitLat = _lat;
            var splitLng = latlng[1];
            splitLng = _lng;

            let newMarker = new google.maps.Marker({
                position: {
                    lat: splitLat,
                    lng: splitLng
                },
                animation: google.maps.Animation.DROP,
                title: markerTitle,
                draggable: true
            });

            newMarker.setMap(map)
            setOverlays([newMarker]);


            _ubicacion.area = "MARKER (" + splitLat + " " + splitLng + ")";
            setUbicacion(_ubicacion);
        }




    };



    const onMapReady = (event) => {
        mapaRef.current = event.map;
        mapaListoEnRef.current = Date.now();
        const verticesGuardados = wktAVertices(ubicacionRef.current && ubicacionRef.current.geocercaPoligono);
        dibujarPoligono(verticesGuardados);
        if (verticesGuardados.length > 0) {
            // encuadra el poligono (y el punto) para que se vea al abrir
            const limites = new google.maps.LatLngBounds();
            verticesGuardados.forEach(v => limites.extend(v));
            const punto = ubicacionRef.current.area && ubicacionRef.current.area.match(/MARKER \(([-\d.]+) ([-\d.]+)\)/);
            if (punto) limites.extend({ lat: parseFloat(punto[1]), lng: parseFloat(punto[2]) });
            event.map.fitBounds(limites);
        }
        let _ubicacion = { ...ubicacion }
        if ((_ubicacion.area == "") || (_ubicacion.area == null)) {
            setOverlays([
            ]);
        } else {
            //var names = 'Harry,John,Clark,Peter,Rohn,Alice';
            // var nameArr = names.split(',');
            // const words = _ubicacion.area.split(',');
            const words2 = _ubicacion.area.split(/[()]+/);
            const latlng = words2[1].split(' ');
            const splitLat = latlng[0];
            const splitLng = latlng[1];

            console.log(splitLat + "," + splitLng);
            //addMarker2(parseFloat(words[0]),parseFloat(words[1]))

            let newMarker = new google.maps.Marker({
                position: {
                    lat: parseFloat(splitLat),
                    lng: parseFloat(splitLng)
                },
                animation: google.maps.Animation.DROP,
                title: markerTitle,
                draggable: true
            });


            newMarker.setMap(map)
            setOverlays([newMarker]);

        }

    };

    // ---- Poligono de la geocerca ----
    ubicacionRef.current = ubicacion;

    const guardarVertices = (vertices) => {
        const wkt = verticesAWkt(vertices);
        setUbicacion(prev => ({ ...prev, geocercaPoligono: wkt }));
        ubicacionRef.current = { ...ubicacionRef.current, geocercaPoligono: wkt };
    };

    const verticesDelPoligono = () => {
        if (!poligonoRef.current) return [];
        return poligonoRef.current.getPath().getArray().map(p => ({ lat: p.lat(), lng: p.lng() }));
    };

    const dibujarPoligono = (vertices) => {
        if (poligonoRef.current) {
            poligonoRef.current.setMap(null);
            poligonoRef.current = null;
        }
        if (!mapaRef.current || !vertices || vertices.length === 0) return;
        const poligono = new google.maps.Polygon({
            paths: vertices,
            editable: modoMapaRef.current === 'poligono',
            strokeColor: '#c62828',
            strokeWeight: 2,
            fillColor: '#c62828',
            fillOpacity: 0.18,
            map: mapaRef.current
        });
        // mover, agregar (punto medio) o quitar vertices sobre el mapa
        const alCambiar = () => guardarVertices(verticesDelPoligono());
        const path = poligono.getPath();
        path.addListener('set_at', alCambiar);
        path.addListener('insert_at', alCambiar);
        path.addListener('remove_at', alCambiar);
        // clic derecho sobre un vertice lo quita
        poligono.addListener('rightclick', (e) => {
            if (e.vertex != null && path.getLength() > 1) path.removeAt(e.vertex);
        });
        poligonoRef.current = poligono;
    };

    const agregarVertice = (lat, lng) => {
        const vertices = [...verticesDelPoligono(), { lat, lng }];
        dibujarPoligono(vertices);
        guardarVertices(vertices);
    };

    const deshacerVertice = () => {
        const vertices = verticesDelPoligono().slice(0, -1);
        dibujarPoligono(vertices);
        guardarVertices(vertices);
    };

    const borrarPoligono = () => {
        dibujarPoligono([]);
        guardarVertices([]);
    };

    const cambiarModoMapa = (modo) => {
        if (!modo) return;
        setModoMapa(modo);
        modoMapaRef.current = modo;
        if (poligonoRef.current) poligonoRef.current.setEditable(modo === 'poligono');
    };

    const cantidadVertices = (u) => wktAVertices(u && u.geocercaPoligono).length;

    const onHide = (event) => {
        setDialogVisible(false);
    };

    const options = {
        center: { lat: ubicacionUsuarioLatitud, lng: ubicacionUsuarioLongitud },
        zoom: 12
    };

    const footer = (
        <div>
            <Button label="Yes" icon="pi pi-check" onClick={addMarker} />
            <Button label="No" icon="pi pi-times" onClick={onHide} />
        </div>
    );

    const clearFilter = () => {
        initFilters();
    };




    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            nombre: { value: null, matchMode: FilterMatchMode.CONTAINS },
            codigo: { value: null, matchMode: FilterMatchMode.CONTAINS },
        });
    };

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        nombre: { value: null, matchMode: FilterMatchMode.CONTAINS },
        codigo: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    const [atributo, setatributo] = useState(null);
    const atributos = [
        { nombre: 'Circular', value: 'Circular' },
        { nombre: 'Lineal', value: 'Lineal' },
        { nombre: 'Marcador', value: 'Marcador' },

    ];

    const formatearFecha = (fecha, formato = 'yyyy-mm-dd hh:mm:ss') => {

        let d = new Date(fecha),
            month = ("0" + (d.getMonth() + 1)).slice(-2),
            day = ("0" + d.getDate()).slice(-2),
            year = d.getFullYear(),
            hour = ("0" + d.getHours()).slice(-2),
            minutes = ("0" + d.getMinutes()).slice(-2),
            seconds = ("0" + d.getSeconds()).slice(-2);

        switch (formato) {
            case 'dd-mm-yyyy': return [day, month, year].join('-');
            case 'yyyy-mm-dd hh:mm:ss': return [year, month, day].join('-').concat(' ').concat([hour, minutes, seconds].join(':'));
            default: return [year, month, day].join('-');
        }
    }

    const showErrorNoInternet = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'No tiene conexión a internet', life: 3000 });
    }

    const showTarjetaGuardada = () => {
        toast2.current.show({ severity: 'Success', summary: 'Success', detail: 'Tarjeta Guardada Correctamente', life: 3000 });
    }



    const blockuiSpinning = (
        <React.Fragment>
            <ProgressSpinner />
        </React.Fragment>
    );

    const guardarTarjeta = () => {

        let _tarjeta = { ...nuevaTarjeta }
        _tarjeta.identificador = identificadorTarjeta;
        let _fechaIngreso = new Date();
        let _fecha = formatearFecha(_fechaIngreso);
        _tarjeta.fechaIngreso = _fecha;
        _tarjeta.tipoTarjeta = tipotarjeta;
        _tarjeta.usuario = usuario;
        setNuevaTarjeta(_tarjeta);
        console.log(_tarjeta);

        var condition = navigator.onLine ? 'online' : 'offline';
        if (condition === 'online') {
            console.log('ONLINE');
            fetch('https://www.google.com/', { // Check for internet connectivity
                mode: 'no-cors',
            })
                .then(() => {
                    console.log('CONNECTED TO INTERNET');
                    ubicacionesService.guardarTarjeta(_tarjeta)
                        .then(() => { ubicacionesService.getListaTarjetas().then(data => setListaTarjetas(data)) })
                        .then(showTarjetaGuardada());
                }).catch(() => {
                    console.log('INTERNET CONNECTIVITY ISSUE');
                    showErrorNoInternet();
                })

        } else {
            showErrorNoInternet();
            console.log('OFFLINE')
        }
        setIdentificadorTarjeta("");
        setTarjetaDialog(false);
    }

    const guardar = () => {
        let _ubicacion = { ...ubicacion }
        if (_ubicacion.geocercaPoligono && cantidadVertices(_ubicacion) < 3) {
            toast2.current.show({ severity: 'warn', summary: 'Polígono incompleto', detail: 'El polígono necesita al menos 3 vértices, o bórrelo.', life: 5000 });
            return;
        }
        if (_ubicacion.esPatioSeco && _ubicacion.delincuenteHoras != null
            && (!Number.isInteger(_ubicacion.delincuenteHoras) || _ubicacion.delincuenteHoras < 1 || _ubicacion.delincuenteHoras > 72)) {
            toast2.current.show({ severity: 'warn', summary: 'Horas para DELINCUENTE', detail: 'Escriba un número entero de 1 a 72, o déjelo vacío para usar el valor general.', life: 5000 });
            return;
        }
        let _ubicacionInformacion = { ...ubicacionInformacion }
        console.log(_ubicacionInformacion);
        _ubicacion.tipoUbicacion = tipoUbicacion;
        _ubicacion.ubicacionInfoList[0] = _ubicacionInformacion;

        if (_ubicacion.area == null || _ubicacion.area == "") {
            _ubicacion.area = null;
        }
        else if (_ubicacion.area.includes("MARKER")) {
            const words2 = _ubicacion.area.split(/[()]+/);
            const latlng = words2[1].split(' ');
            const splitLat = latlng[0];
            const splitLng = latlng[1];
            _ubicacion.area = "MARKER (" + splitLat + " " + splitLng + ")";
        }
        else {

            const words = _ubicacion.area.split(',');
            console.log("Latitud: " + words[0]);
            console.log("Longitud: " + words[1]);
            _ubicacion.area = "";
            _ubicacion.area = "MARKER (" + words[0] + " " + words[1] + ")";
        }



        setUbicacion(_ubicacion);
        console.log(_ubicacion);

        var condition = navigator.onLine ? 'online' : 'offline';
        if (condition === 'online') {
            console.log('ONLINE');
            fetch('https://www.google.com/', { // Check for internet connectivity
                mode: 'no-cors',
            })
                .then(() => {
                    console.log('CONNECTED TO INTERNET');
                    console.log(_ubicacion);
                    ubicacionesService.guardarUbicacion(_ubicacion)
                        .then(showSuccess())
                        .then(() => ubicacionesService.getListaUbicaciones().then(data => { setUbicaciones(data) })
                            .then(clearFilter()));
                }).catch(() => {
                    console.log('INTERNET CONNECTIVITY ISSUE');
                    showErrorNoInternet();
                })

        } else {
            showErrorNoInternet();
            console.log('OFFLINE')
        }
        setUbicacionDialog(false);
    }

    const showSuccess = () => {
        toast.current.show({ severity: 'success', summary: 'Success', detail: 'Ubicación se ha Guardado', life: 3000 });
    }

    const showTarjetaNuevaDialog = () => {
        setTarjetaDialog(true);
    }


    const hideTarjetaNuevaDialog = () => {
        setNuevaTarjeta("");
        setTipoTarjeta("");
        setIdentificadorTarjeta("");
        setTarjetaDialog(false);
    }

    const hideRutaNuevaDialog = () => {

        setRutaDialog(false);
    }


    const hideDialog = () => {
        setSubmitted(false);
        setUbicacionDialog(false);
        setHabilitarGuardar(true);
        setTarjeta("");
        setTipoUbicacion("");
        setUbicacionInformacion("");
        setUbicacion("");
    }

    const editMonitoreoDet = (ubicacion) => {

        let _ubicacion = { ...ubicacion };
        let _ubicacionInformacion = {};
        setUbicacionId(_ubicacion.ubicacionId);
        setTipoUbicacion(_ubicacion.tipoUbicacion);
        ubicacionesService.getListaUbicacionesPorIdyEstado(_ubicacion.ubicacionId).then(data => {
            _ubicacion = data;
            _ubicacionInformacion = (data.ubicacionInfoList && data.ubicacionInfoList[0]) ? data.ubicacionInfoList[0] : {};
            setUbicacionInformacion(_ubicacionInformacion);
            setUbicacion(_ubicacion);
            console.log(_ubicacion);
            console.log(_ubicacionInformacion);
        });
        setUbicacionDialog(true);
    }

    const nuevaUbicacion = () => {
        setUbicacion(_ubicacion);
        setUbicacionDialog(true);
    }

    const nuevaRuta = () => {

        setRutaDialog(true);
    }


    const eliminarTarjeta = (ubicacionTarjeta) => {
        let _ubicacionTarjeta = {
            "ubicacionTarjetaId": 0,
            "activo": true,
            "estado": "Activo",
            "fechaIngreso": "",
            "tarjeta": {},
            "usuario": {}
        }
        _ubicacionTarjeta = ubicacionTarjeta;
        _ubicacionTarjeta.estado = "Eliminado"

        let _ubicacion = { ...ubicacion };

        _ubicacion.ubicacionTarjetaList.forEach((ubicacionTarjeta2, index) => {
            if (ubicacionTarjeta2.tarjeta.tarjetaId === _ubicacionTarjeta.tarjeta.tarjetaId && ubicacionTarjeta2.ubicacionTarjetaId) {
                ubicacionTarjeta2 = _ubicacionTarjeta;
            }
            if (ubicacionTarjeta2.tarjeta.tarjetaId === _ubicacionTarjeta.tarjeta.tarjetaId && ubicacionTarjeta2.ubicacionTarjetaId === null) {
                _ubicacion.ubicacionTarjetaList.splice(index, 1);
            }
        });
        setUbicacion(_ubicacion);
    }

    const agregaTarjeta = () => {

        let _ubicacionTarjeta = {
            "ubicacionTarjetaId": null,
            "activo": true,
            "estado": "Activo",
            "fechaIngreso": "",
            "tarjeta": {},
            "usuario": {}
        }
        _ubicacionTarjeta.tarjeta = tarjeta;
        _ubicacionTarjeta.usuario = usuario;
        let _ubicacion = { ...ubicacion };

        if (_ubicacion.ubicacionTarjetaList === null) {
            _ubicacion.ubicacionTarjetaList = [];
        }
        _ubicacion.ubicacionTarjetaList.push(_ubicacionTarjeta);
        setUbicacion(_ubicacion);
        console.log(_ubicacion);
    }

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _monitoreoDet = { ...ubicacion };
        if (name === 'monitoreoDetProceso') {
            let _monitoreoDetProceso = _monitoreoDet[`${name}`];
            _monitoreoDetProceso.estadoProceso = val;
            _monitoreoDetProceso.monitoreoDetProcesoId = 0;
            _monitoreoDet[`${name}`] = _monitoreoDetProceso;
        } else {
            _monitoreoDet[`${name}`] = val;
        }
        setUbicacion(_monitoreoDet);
    }

    const onInputChangeUbicacionInformacion = (e, name) => {

        {
            const val = (e.target && e.target.value) || '';
            let _ubicacionInformacion = { ...ubicacionInformacion };
            _ubicacionInformacion[`${name}`] = val;
            setUbicacionInformacion(_ubicacionInformacion);
        }
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-user-edit" label='Editar' className="p-button-rounded p-button-success mr-2" onClick={() => editMonitoreoDet(rowData)} />
            </React.Fragment>
        );
    }

    const actionBodyTarjetasTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button label='Eliminar' className="p-button-rounded p-button-success mr-2" onClick={() => eliminarTarjeta(rowData)} disabled={!isUbicacionTarjeta} />
            </React.Fragment>
        );
    }


    const productDialogFooter = (
        <React.Fragment>
            <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label="Save" icon="pi pi-check" className="p-button-text" onClick={guardar} disabled={!isAdmin} />
        </React.Fragment>
    );

    const tarjetaNuevaDialogFooter = (
        <React.Fragment>
            <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={hideTarjetaNuevaDialog} />
            <Button label="Guardar" icon="pi pi-check" className="p-button-text" onClick={guardarTarjeta} />
        </React.Fragment>
    );

    const rutaNuevaDialogFooter = (
        <React.Fragment>
            <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={hideRutaNuevaDialog} />
            <Button label="Guardar" icon="pi pi-check" className="p-button-text" />
        </React.Fragment>
    );


    const onChangeTarjetaSeleccionada = (e) => {
        setTarjeta(e.value);
    }

    const onChangeTipoTarjetaSeleccionada = (e) => {
        setTipoTarjeta(e.value);
    }

    const onChangeTipoUbicacionSeleccionada = (e) => {
        setTipoUbicacion(e.value);
    }

    const getCurrentLocatino = () => {
        navigator.geolocation.getCurrentPosition(successCallback, errorCallback);
    }

    const successCallback = (position) => {
        console.log(position);
    };

    const errorCallback = (error) => {
        console.log(error);
    };




    const onBasicUpload = (message) => {
        toast.current.show({ severity: 'info', summary: 'Success', detail: message, sticky: true });
    }


    const padreMarker = (lat, lng) => {
        console.log(lat, lng);
        let _monitoreoDet = { ...ubicacion };
        _monitoreoDet.area = (lat + "," + lng);
        setUbicacion(_monitoreoDet);

    }

    const mostrarMapa = () => {

        let _ubicacion = { ...ubicacion }
        if ((_ubicacion.area == "") || (_ubicacion.area == null)) {
            setOverlays([
            ]);
        } else {
            //var names = 'Harry,John,Clark,Peter,Rohn,Alice';
            // var nameArr = names.split(',');
            // const words = _ubicacion.area.split(',');

            const words2 = _ubicacion.area.split(/[()]+/);
            const latlng = words2[1].split(' ');
            const splitLat = latlng[0];
            const splitLng = latlng[1];
            console.log(splitLat + "," + splitLng);

            console.log("Latitud: " + splitLat);
            console.log("Longitud: " + splitLng);
            setUbicacionUsuarioLatitud(parseFloat(splitLat));
            setUbicacionUsuarioLongitud(parseFloat(splitLng));

            //addMarker2(parseFloat(words[0]),parseFloat(words[1]))

            let newMarker = new google.maps.Marker({
                position: {
                    lat: parseFloat(splitLat),
                    lng: parseFloat(splitLng)
                },
                animation: google.maps.Animation.DROP,
                title: markerTitle,
                draggable: true
            });


            newMarker.setMap(map)
            setOverlays([newMarker]);

        }
        cambiarModoMapa(ubicacion && ubicacion.geocercaPoligono ? 'poligono' : 'punto');
        setDisplayMapa(true);
    }

    return (
        <div className="datatable-crud-demo">
            <Toast ref={toast} />

            <div className="card p-fluid">
                <div className="formgrid grid">

                    <div className="field col-12 md:col-12 lg:col-6 sm:col-12">
                        <label htmlFor="subirArchivo">&nbsp;</label>
                        <Button id="subirArchivo" label="Subir Archivo" className="p-button-help p-button-raised" onClick={() => {

                            setArchivoDialog(true);
                            getCurrentLocatino();
                        }} />


                        <Dialog visible={archivoDialog} style={{ width: '50vw' }} onHide={() => setArchivoDialog(false)}>
                            <FileUpload name="opem-test"

                                url={`${BASE_URL}/ubicacion/upload-file/validar-ubicacion`}
                                multiple
                                accept=".csv,.xls,.xlsx"
                                maxFileSize={1000000}
                                onUpload={onBasicUpload}
                                emptyTemplate={<p className="m-0">Subir archivo para verificar ubicaciones existentes.</p>} />
                        </Dialog>

                    </div>

                    <div className="field col-12 md:col-12 lg:col-6 sm:col-12">
                        <label htmlFor="nuevaUbicacion">&nbsp;</label>
                        <Button id="nuevaUbicacion" label="Nueva Ubicación" className="p-button-help p-button-raised" onClick={nuevaUbicacion} />
                    </div>


                </div>
            </div>
            <div className="card">
                <DataTable ref={dt} paginator rows={5} rowsPerPageOptions={[5, 10]} scrollable scrollHeight="400px" value={ubicaciones} selection={selectedMonitoreoDet} onSelectionChange={(e) => setSelectedMonitoreoDets(e.value)}
                    dataKey="ubicacionId" filters={filters} globalFilterFields={['nombre', 'codigo', 'latitud', 'longitud', 'tipoUbicacion.nombre']} filterDisplay="row" responsiveLayout="scroll">
                    <Column field="nombre" filter filterPlaceholder="Buscar nombre" showFilterMenu={false} header="Nombre" style={{ minWidth: '13rem' }}></Column>
                    <Column field="codigo" filter filterPlaceholder="Buscar código" showFilterMenu={false} header="Codigo" style={{ minWidth: '13rem' }}></Column>

                    <Column field="tipoUbicacion.nombre" header="Tipo de Ubicación" style={{ minWidth: '4rem' }}></Column>
                    <Column field="distanciaKm" header="Distancia (km)" style={{ minWidth: '4rem' }}
                        body={(row) => row.distanciaKm != null ? `${row.distanciaKm} km` : ''}></Column>

                    <Column header="Polígono" style={{ minWidth: '4rem' }}
                        body={(row) => row.geocercaPoligono ? <i className="pi pi-check" title="Tiene polígono"></i> : ''}></Column>
                    <Column header="Punto de retorno" style={{ minWidth: '4rem' }}
                        body={(row) => row.esPuntoRetorno ? <i className="pi pi-check" title="Punto de retorno"></i> : ''}></Column>
                    <Column header="Patio seco" style={{ minWidth: '4rem' }}
                        body={(row) => row.esPatioSeco
                            ? <span title="Patio seco (control de tramos R9/R11)"><i className="pi pi-check"></i>{row.delincuenteHoras ? ' ' + row.delincuenteHoras + ' h' : ''}</span>
                            : ''}></Column>
                    <Column body={actionBodyTemplate} exportable={false} style={{ minWidth: '8rem' }}></Column>
                </DataTable>
            </div>


            <Dialog visible={ubicacionDialog} style={{ width: '90vw' }} header="Detalles de Ubicación" modal className="p-fluid" footer={productDialogFooter} onHide={hideDialog}>
                <Toast ref={toast2} />
                <div className="col-12">
                    <div className="card p-fluid">
                        <div className="field">
                            <label htmlFor="listaTipoUbicaciones">Tipo de Ubicación</label>
                            <div className="p-inputgroup">
                                <Dropdown id='listaTipoUbicaciones' options={listaTipoUbicaciones} optionLabel="nombre" value={tipoUbicacion} onChange={onChangeTipoUbicacionSeleccionada} placeholder="Selecciona un Tipo de Ubicacion"
                                    filter className="w-full md:w-14rem" />
                            </div>
                        </div>
                        <div className="field ">
                            <label htmlFor="nombre">Nombre</label>
                            <InputText type="text" style={{ opacity: 1 }} name="nombre" id="nombre" value={ubicacion.nombre || ''} onChange={(e) => onInputChange(e, 'nombre')} required className={classNames({ 'p-invalid': submitted && !ubicacion.nombre })} />
                        </div>
                        <div className="field ">
                            <label htmlFor="codigo">Código</label>
                            <InputText type="text" style={{ opacity: 1 }} name="codigo" id="codigo" value={ubicacion.codigo || ''} onChange={(e) => onInputChange(e, 'codigo')} required className={classNames({ 'p-invalid': submitted && !ubicacion.codigo })} />
                        </div>

                        <div className="field ">
                            <div className="col-6 md:col-6">
                                <label htmlFor="area">Área</label>
                                <div id="area" className="p-inputgroup">
                                    <InputText disabled value={ubicacion.area || ''} onChange={(e) => onInputChange(e, 'area')} />
                                    <Button icon="pi pi-map" onClick={mostrarMapa} disabled={!isAdmin} />
                                </div>
                            </div>
                        </div>

                        {/* ---- DOLE tramos a puerto: geocerca y punto de retorno ---- */}
                        <div className="field">
                            <label>Geocerca (polígono)</label>
                            <div className="p-inputgroup">
                                <InputText id="geocercaPoligonoResumen" disabled
                                    value={cantidadVertices(ubicacion) > 0 ? 'Polígono de ' + cantidadVertices(ubicacion) + ' vértices' : 'Sin polígono: se usa el punto con su radio'} />
                                <Button icon="pi pi-pencil" label="Dibujar" onClick={mostrarMapa} disabled={!isAdmin} />
                            </div>
                            <small>Opcional. Lo usa el seguimiento a puerto (ingreso y salida). Si no tiene polígono, se usa el punto.</small>
                        </div>
                        <div className="field-checkbox">
                            <Checkbox inputId="esPuntoRetorno" checked={!!ubicacion.esPuntoRetorno} disabled={!isAdmin}
                                onChange={(e) => setUbicacion(prev => ({ ...prev, esPuntoRetorno: e.checked }))} />
                            <label htmlFor="esPuntoRetorno">Punto de retorno: aquí se retira el candado después de entregar en el puerto</label>
                        </div>
                        {/* ---- DOLE control de tramos: patio seco (cada cambio queda registrado) ---- */}
                        <div className="field-checkbox">
                            <Checkbox inputId="esPatioSeco" checked={!!ubicacion.esPatioSeco} disabled={!isAdmin}
                                onChange={(e) => setUbicacion(prev => ({ ...prev, esPatioSeco: e.checked, delincuenteHoras: e.checked ? prev.delincuenteHoras : null }))} />
                            <label htmlFor="esPatioSeco">Es patio seco: los viajes desde R9/R11 hasta aquí se controlan como tramo propio</label>
                        </div>
                        {ubicacion.esPatioSeco && (
                            <div className="field">
                                <label htmlFor="delincuenteHoras">Horas para DELINCUENTE desde la salida de R9/R11</label>
                                <InputText type="number" min="1" max="72" step="1" id="delincuenteHoras" disabled={!isAdmin}
                                    value={ubicacion.delincuenteHoras ?? ''}
                                    onChange={(e) => setUbicacion(prev => ({ ...prev, delincuenteHoras: e.target.value === '' ? null : parseInt(e.target.value, 10) }))} />
                                <small>Vacío = el valor general del sistema. De 1 a 72 horas.</small>
                            </div>
                        )}

                        {/* ---- Campos nuevos DOLE (RF-B4 / RF-B8 / RF-C1) ---- */}
                        <div className="field ">
                            <label htmlFor="tttHoras">TTT (horas desde BNP)</label>
                            <InputText type="text" style={{ opacity: 1 }} name="tttHoras" id="tttHoras"
                                value={ubicacion.tttHoras ?? ''} onChange={(e) => onInputChange(e, 'tttHoras')} />
                            <small>Tiempo de tránsito terrestre. Se usa para calcular ETA R10 = F. Inicio Lleno + TTT.</small>
                        </div>
                        <div className="field ">
                            <label htmlFor="distanciaKm">Distancia (km)</label>
                            <InputText type="text" style={{ opacity: 1 }} name="distanciaKm" id="distanciaKm"
                                value={ubicacion.distanciaKm ?? ''} onChange={(e) => onInputChange(e, 'distanciaKm')} />
                            <small>Distancia de un solo sentido (one way) hasta el punto de carga.</small>
                        </div>
                        <div className="field ">
                            <label htmlFor="cantonLocalidadDetId">Cantón / Localidad</label>
                            <Dropdown id="cantonLocalidadDetId" options={cantonesLocalidad} optionLabel="nombre" optionValue="configuracionDetId"
                                value={ubicacion.cantonLocalidadDetId || null}
                                onChange={(e) => onInputChange({ target: { value: e.value } }, 'cantonLocalidadDetId')}
                                placeholder="Selecciona un cantón / localidad" filter showClear />
                            <small>Se gestiona en Maestros DOLE (Cantones / Localidades).</small>
                        </div>
                        <div className="field ">
                            <label htmlFor="zonaProduccionDetId">Zona de Producción</label>
                            <Dropdown id="zonaProduccionDetId" options={zonasProduccion} optionLabel="nombre" optionValue="configuracionDetId"
                                value={ubicacion.zonaProduccionDetId || null}
                                onChange={(e) => onInputChange({ target: { value: e.value } }, 'zonaProduccionDetId')}
                                placeholder="Selecciona una zona" showClear />
                            <small>Se gestiona en Maestros DOLE. Alimenta el filtro de Zona en Logística.</small>
                        </div>

                        <div className="field ">
                            <label htmlFor="listaAtributos">Atributo</label>
                            <div className="p-inputgroup">
                                <Dropdown id='listaAtributos' options={atributos} value={atributo || ''} onChange={(e) => setatributo(e.value)} optionLabel="nombre" placeholder="Selecciona un atributo"
                                    filter className="w-full md:w-14rem" />
                            </div>
                        </div>

                        <div className="card p-fluid">
                            <TabView>
                                <TabPanel header="Tarjetas">

                                    <div className="formgrid grid">
                                        <div className="field col-6">
                                            <label htmlFor="listaTarjetas">Lista de Tarjetas</label>
                                            <div className="p-inputgroup">
                                                <Dropdown id='listaTarjetas' options={listaTarjetas} optionLabel="identificador" value={tarjeta} onChange={onChangeTarjetaSeleccionada} placeholder="Selecciona una tarjeta"
                                                    filter className="w-full md:w-14rem" />
                                            </div>
                                        </div>
                                        <div className="field col-3">
                                            <label htmlFor="agregarTarjeta">&nbsp;</label>
                                            <Button id="agregarTarjeta" label="Asignar" className="p-button-raised" onClick={agregaTarjeta} icon="pi pi-check" iconPos="right" disabled={!isUbicacionTarjeta} />
                                        </div>

                                        <div className="field col-3">
                                            <label htmlFor="nuevaTarjeta">&nbsp;</label>
                                            <Button id="nuevaTarjeta" label="Nueva Tarjeta" className="p-button-help p-button-raised" icon="pi pi-plus" iconPos="right" onClick={showTarjetaNuevaDialog} disabled={!isUbicacionTarjeta} />
                                        </div>
                                    </div>

                                    <BlockUI blocked={blocked} template={blockuiSpinning}>

                                        <DataTable ref={dt} paginator rows={5} rowsPerPageOptions={[5, 10]} scrollable scrollHeight="400px" value={ubicacion.ubicacionTarjetaList}
                                            dataKey="ubicacionTarjetaId" filters={filters} filterDisplay="row" responsiveLayout="scroll">
                                            <Column field="tarjeta.identificador" header="Tarjeta" style={{ minWidth: '2rem' }}></Column>
                                            <Column field="estado" header="Estado" style={{ minWidth: '2rem' }}></Column>
                                            <Column body={actionBodyTarjetasTemplate} exportable={false} style={{ minWidth: '8rem' }}></Column>
                                        </DataTable>
                                    </BlockUI>


                                </TabPanel>
                                <TabPanel header="Información">


                                    <div className="card p-fluid">

                                        <div className="formgrid grid">

                                            <div className="field col-6 md:col-6 lg:col-6 sm:col-6">
                                                <label htmlFor="representante">Representante</label>
                                                <InputText type="text" value={ubicacionInformacion.representante} onChange={(e) => onInputChangeUbicacionInformacion(e, 'representante')} style={{ opacity: 1 }} />
                                            </div>
                                            <div className="field col-6 md:col-6 lg:col-6 sm:col-6">
                                                <label htmlFor="telefonoRepresentante">Teléfono del Representante</label>
                                                <InputText type="text" value={ubicacionInformacion.representanteTelefono} onChange={(e) => onInputChangeUbicacionInformacion(e, 'representanteTelefono')} style={{ opacity: 1 }} />
                                            </div>

                                            <div className="field col-6">
                                                <label htmlFor="correoRepresentante">Correo del Representante</label>
                                                <InputText type="text" style={{ opacity: 1 }} value={ubicacionInformacion.representanteCorreo || ""} onChange={(e) => onInputChangeUbicacionInformacion(e, 'representanteCorreo')} />
                                            </div>

                                            <div className="field col-6">
                                                <label htmlFor="responsable">Responsable</label>
                                                <InputText type="text" style={{ opacity: 1 }} value={ubicacionInformacion.responsable || ""} onChange={(e) => onInputChangeUbicacionInformacion(e, 'responsable')} />
                                            </div>

                                            <div className="field col-6">
                                                <label htmlFor="identificacionResponsable">Identificación del Responsable</label>
                                                <InputText type="text" style={{ opacity: 1 }} value={ubicacionInformacion.responsableIdentificacion || ""} onChange={(e) => onInputChangeUbicacionInformacion(e, 'responsableIdentificacion')} />
                                            </div>

                                            <div className="field col-6">
                                                <label htmlFor="telefonoResponsable">Teléfono del Responsable</label>
                                                <InputText type="text" style={{ opacity: 1 }} value={ubicacionInformacion.responsableTelefono || ""} onChange={(e) => onInputChangeUbicacionInformacion(e, 'responsableTelefono')} />
                                            </div>

                                            <div className="field col-6">
                                                <label htmlFor="zona">Zona</label>
                                                <InputText type="text" style={{ opacity: 1 }} value={ubicacionInformacion.zona || ""} onChange={(e) => onInputChangeUbicacionInformacion(e, 'zona')} />
                                            </div>

                                            <div className="field col-6">
                                                <label htmlFor="codigoPlantaEmpacadora">Código Planta Empacadora</label>
                                                <InputText type="text" style={{ opacity: 1 }} value={ubicacionInformacion.codigoPlantaEmpacadora || ""} onChange={(e) => onInputChangeUbicacionInformacion(e, 'codigoPlantaEmpacadora')} />
                                            </div>

                                            <div className="field col-6">
                                                <label htmlFor="sector">Sector</label>
                                                <InputText type="text" style={{ opacity: 1 }} value={ubicacionInformacion.sector || ""} onChange={(e) => onInputChangeUbicacionInformacion(e, 'sector')} />
                                            </div>

                                            <div className="field col-6">
                                                <label htmlFor="provincia">Provincia</label>
                                                <InputText type="text" style={{ opacity: 1 }} value={ubicacionInformacion.provincia || ""} onChange={(e) => onInputChangeUbicacionInformacion(e, 'provincia')} />
                                            </div>

                                            <div className="field col-6">
                                                <label htmlFor="provincia">Canton</label>
                                                <InputText type="text" style={{ opacity: 1 }} value={ubicacionInformacion.canton || ""} onChange={(e) => onInputChangeUbicacionInformacion(e, 'canton')} />
                                            </div>

                                            <div className="field col-6">
                                                <label htmlFor="provincia">Contenedores por Día</label>
                                                <InputText type="text" style={{ opacity: 1 }} value={ubicacionInformacion.contenedoresPorDia || ""} onChange={(e) => onInputChangeUbicacionInformacion(e, 'contenedoresPorDia')} />
                                            </div>



                                        </div>
                                    </div>


                                </TabPanel>

                            </TabView>
                        </div>


                    </div>

                </div>

            </Dialog>


            <Dialog visible={tarjetaDialog} style={{ width: '90vw' }} header="Detalles de Tarjeta" modal className="p-fluid" footer={tarjetaNuevaDialogFooter} onHide={hideTarjetaNuevaDialog}>

                <div className="col-12">
                    <div className="card p-fluid">

                        <div className="field">
                            <label htmlFor="listaTarjetas">Lista Tipo de Tarjetas</label>
                            <div className="p-inputgroup">
                                <Dropdown id='listaTarjetas' options={listaTipoTarjetas} optionLabel="nombre" value={tipotarjeta} onChange={onChangeTipoTarjetaSeleccionada} placeholder="Selecciona un tipo de tarjeta"
                                    filter className="w-full md:w-14rem" />
                            </div>
                        </div>
                        <div className="field ">
                            <label htmlFor="nombre">identificador</label>
                            <InputText type="text" style={{ opacity: 1 }} name="identificador" id="identificador" value={identificadorTarjeta} onChange={(e) => setIdentificadorTarjeta(e.target.value)} required className={classNames({ 'p-invalid': submitted && !identificadorTarjeta })} />
                        </div>
                    </div>

                </div>

            </Dialog>



            <Dialog header="Mapa" visible={displayMapa} style={{ width: '80vw' }} onHide={() => { setDisplayMapa(false); }}>
                {googleMapsReady && (
                    <div className="card">
                        <div className="flex flex-wrap align-items-center gap-2 mb-2">
                            <SelectButton id="modoMapa" value={modoMapa} onChange={(e) => cambiarModoMapa(e.value)}
                                options={[{ label: 'Punto', value: 'punto' }, { label: 'Polígono', value: 'poligono' }]} />
                            {modoMapa === 'poligono' && (
                                <>
                                    <Button id="deshacerVertice" type="button" icon="pi pi-undo" label="Deshacer vértice" className="p-button-outlined p-button-sm"
                                        onClick={deshacerVertice} disabled={cantidadVertices(ubicacion) === 0} />
                                    <Button id="borrarPoligono" type="button" icon="pi pi-trash" label="Borrar polígono" className="p-button-outlined p-button-danger p-button-sm"
                                        onClick={borrarPoligono} disabled={cantidadVertices(ubicacion) === 0} />
                                    <small id="ayudaPoligono">{cantidadVertices(ubicacion)} vértices · Clic en el mapa agrega un vértice; arrastre los puntos para moverlos; clic derecho sobre un punto lo quita.</small>
                                </>
                            )}
                            {modoMapa === 'punto' && <small>Clic en el mapa ubica el punto de la ubicación.</small>}
                        </div>
                        <GMap
                            overlays={overlays}
                            options={options}
                            style={{ width: "100%", minHeight: "320px" }}
                            onMapReady={onMapReady}
                            onMapClick={onMapClick}
                            onOverlayClick={onOverlayClick}
                            onOverlayDragEnd={handleDragEnd}
                        />
                    </div>
                )}
            </Dialog>

        </div>
    );
}


export default Ubicaciones;
